import { render } from "./AdditionalApps.vue?vue&type=template&id=159c4905&scoped=true"
import script from "./AdditionalApps.vue?vue&type=script&lang=js"
export * from "./AdditionalApps.vue?vue&type=script&lang=js"

import "./AdditionalApps.vue?vue&type=style&index=0&id=159c4905&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159c4905"]])

export default __exports__